import React from 'react'

export default function InfoTab({data,activeTab,setActiveTab}) {
  return (
    <div className='w-full bg-white border-b-[1px] border-b-[1px solid #e3e3e3] flex justify-between px-0 md:px-0 mt-3' >
        <div className='flex justify-start'>
        {
            [{value:'in-house',label:'In-House'},{value:'flooring',label:'Flooring'}].map((item,index)=>
            {
                return <div onClick={()=>setActiveTab(item.value)} className={` after:block py-1 px-2 md:py-2 md:px-3 relative cursor-pointer ${activeTab === item.value ? 'after:w-full after:bg-[#0560FB] after:h-[3px] after:bottom-0 after:left-0 after:absolute group active' : ''}`}>
                    <p className='text-[11px] md:text-[13px] font-semibold text-[#656565] capitalize tracking-[-.35px] group-[.active]:text-[#0560FB]'>{item.label}</p>
                </div>
            })
        }
        </div>
        <div>
        </div>
    </div>
  )
}
